/*
  AUKSales redesign (October 2026).
  Each block below is a separate IIFE that finds its own markup and does
  nothing when that markup is absent, so one feature failing cannot stop the
  others. assets/theme.js is deliberately untouched (its product tab parser
  is off limits).
*/

/* -- Storage helper: private windows and blocked storage throw, and the page
      must still render correctly when they do. -- */
var aukStore = {
  get: function (key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  },
  set: function (key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* storage unavailable */ }
  }
};

function aukOnCartOrCheckout() {
  var path = window.location.pathname;
  return /\/cart(\/|$)/.test(path) || /\/checkout/.test(path) || /\/checkouts\//.test(path);
}

/* -- Job 11b: delivery roadmap, in business days, always as a range -- */
(function () {
  var roadmap = document.querySelector('[data-delivery-roadmap]');
  if (!roadmap) return;

  function addBusinessDays(from, days) {
    var date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var left = Math.max(0, days);
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) left -= 1;
    }
    return date;
  }

  function format(date) {
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function range(from, min, max) {
    var start = addBusinessDays(from, min);
    var end = addBusinessDays(from, max);
    if (start.getTime() === end.getTime()) return format(start);
    return format(start) + ' – ' + format(end);
  }

  function number(name, fallback) {
    var value = parseInt(roadmap.getAttribute(name), 10);
    return isNaN(value) ? fallback : value;
  }

  var today = new Date();
  var slots = {
    purchased: format(today),
    processing: range(today, number('data-processing-min', 1), number('data-processing-max', 3)),
    delivered: range(today, number('data-delivery-min', 7), number('data-delivery-max', 10))
  };
  Object.keys(slots).forEach(function (key) {
    var node = roadmap.querySelector('[data-roadmap-date="' + key + '"]');
    if (node) node.textContent = slots[key];
  });
  roadmap.classList.add('has-dates');
})();

/* -- Job 11h: recently viewed, per browser, newest first, capped at 8 -- */
(function () {
  var root = document.querySelector('[data-recently-viewed]');
  if (!root || !window.fetch) return;
  var grid = root.querySelector('[data-recently-viewed-grid]');
  var current = root.getAttribute('data-current-handle');
  var KEY = 'auksales_recently_viewed';
  var list = [];
  try { list = JSON.parse(aukStore.get(KEY) || '[]'); } catch (e) { list = []; }
  if (!Array.isArray(list)) list = [];
  list = list.filter(function (handle) { return typeof handle === 'string' && handle; });

  /* Record this product for the next page, without showing it here. */
  var updated = [current].concat(list.filter(function (handle) { return handle !== current; })).slice(0, 8);
  aukStore.set(KEY, JSON.stringify(updated));

  var toShow = list.filter(function (handle) { return handle !== current; }).slice(0, 4);
  if (!toShow.length || !grid) return;

  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  Promise.all(toShow.map(function (handle) {
    return fetch(base + 'products/' + encodeURIComponent(handle) + '?sections=product-card-render')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) { return data && data['product-card-render'] ? data['product-card-render'] : ''; })
      .catch(function () { return ''; });
  })).then(function (htmls) {
    var holder = document.createElement('div');
    var added = 0;
    htmls.forEach(function (html) {
      if (!html) return;
      holder.innerHTML = html;
      var card = holder.querySelector('.product-card');
      if (!card) return;
      /* Cards are revealed by an observer in theme.js that has already run. */
      card.classList.add('is-visible');
      grid.appendChild(card);
      added += 1;
    });
    if (added > 0) root.hidden = false;
  });
})();

/* -- Job 11i: sticky add-to-cart strip, driving the real product form -- */
(function () {
  var strip = document.querySelector('[data-sticky-atc]');
  var mainButton = document.querySelector('[data-main-atc]');
  if (!strip || !mainButton || !('IntersectionObserver' in window) || aukOnCartOrCheckout()) return;
  var form = mainButton.form;
  var mainQty = form ? form.querySelector('input[name="quantity"]') : null;
  var stickyQty = strip.querySelector('[data-sticky-qty]');
  var stickyButton = strip.querySelector('[data-sticky-submit]');
  if (!form || !stickyButton) return;

  function setVisible(visible) {
    strip.classList.toggle('is-visible', visible);
    strip.setAttribute('aria-hidden', visible ? 'false' : 'true');
    [stickyQty, stickyButton].forEach(function (node) {
      if (node) node.tabIndex = visible ? 0 : -1;
    });
    document.documentElement.classList.toggle('has-sticky-atc', visible);
  }

  /* The header is sticky, so the button is out of sight once it slides
     under the header, not when it leaves the viewport. */
  var header = document.querySelector('.site-header');
  var headerHeight = header ? header.offsetHeight : 0;
  new IntersectionObserver(function (entries) {
    var entry = entries[0];
    /* Only once the real button has scrolled up out of view, not before it. */
    setVisible(!entry.isIntersecting && entry.boundingClientRect.top < headerHeight);
  }, { rootMargin: '-' + headerHeight + 'px 0px 0px 0px' }).observe(mainButton);

  if (mainQty && stickyQty) {
    mainQty.addEventListener('input', function () { stickyQty.value = mainQty.value; });
    stickyQty.addEventListener('input', function () { mainQty.value = stickyQty.value; });
  }

  stickyButton.addEventListener('click', function () {
    if (mainQty && stickyQty) mainQty.value = stickyQty.value;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(mainButton);
    else mainButton.click();
  });
})();

/* -- Job 13: main nav dropdowns (Shop by Category mega menu, Information) -- */
(function () {
  var items = document.querySelectorAll('[data-nav-dropdown]');
  if (!items.length) return;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var usingKeyboard = false;
  document.addEventListener('keydown', function (event) { if (event.key === 'Tab') usingKeyboard = true; });
  document.addEventListener('mousedown', function () { usingKeyboard = false; });
  document.addEventListener('touchstart', function () { usingKeyboard = false; }, { passive: true });

  function setOpen(item, open) {
    var trigger = item.querySelector('.main-nav__trigger');
    if (open && !item.classList.contains('is-open')) item.setAttribute('data-opened-at', String(Date.now()));
    item.classList.toggle('is-open', open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except) {
    items.forEach(function (item) { if (item !== except) setOpen(item, false); });
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('.main-nav__trigger');
    var hoverTimer;
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      /* With a mouse, hovering already opened the panel a moment ago; the
         click that follows must not immediately close it again. */
      var openedAt = parseInt(item.getAttribute('data-opened-at'), 10) || 0;
      if (canHover && item.classList.contains('is-open') && Date.now() - openedAt < 600) return;
      var open = !item.classList.contains('is-open');
      closeAll(item);
      setOpen(item, open);
    });

    if (canHover) {
      item.addEventListener('mouseenter', function () {
        window.clearTimeout(hoverTimer);
        closeAll(item);
        setOpen(item, true);
      });
      item.addEventListener('mouseleave', function () {
        hoverTimer = window.setTimeout(function () { setOpen(item, false); }, 180);
      });
    }

    item.addEventListener('focusin', function () {
      if (!usingKeyboard) return;
      closeAll(item);
      setOpen(item, true);
    });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) setOpen(item, false);
    });

    item.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
      event.stopPropagation();
      setOpen(item, false);
      trigger.focus();
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-nav-dropdown]')) closeAll();
  });
})();

/* -- Job 9: tab title changes while the visitor is away --
   Swaps document.title when the tab is hidden and restores the exact
   original on return. Never on cart or checkout. Restores on
   visibilitychange, focus and pageshow so a back/forward-cache restore
   cannot leave the title stuck. No favicon swap, no sound. */
(function () {
  if (aukOnCartOrCheckout()) return;
  var originalTitle = document.title;
  var awayTitle = '⚡ Come Back !!!';

  function restore() {
    if (document.title === awayTitle) document.title = originalTitle;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      if (document.title !== awayTitle) originalTitle = document.title;
      document.title = awayTitle;
    } else {
      restore();
    }
  });
  window.addEventListener('focus', restore);
  window.addEventListener('pageshow', restore);
})();

/* -- Job 12b: welcome offer modal --
   Once per visitor (dismissal kept in localStorage, wrapped in try/catch),
   after a delay, never on cart/checkout. Esc closes, focus is trapped while
   open and returned on close. Sets html.welcome-open so a future purchase
   toast can stay hidden while the modal is up. */
(function () {
  var modal = document.querySelector('[data-welcome-modal]');
  if (!modal || aukOnCartOrCheckout()) return;
  var KEY = 'auksales_welcome_seen';
  if (aukStore.get(KEY)) return;
  var dialog = modal.querySelector('[role="dialog"]');
  var lastFocus = null;
  var delay = (parseInt(modal.getAttribute('data-welcome-delay'), 10) || 8) * 1000;

  function focusables() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (node) { return node.offsetParent !== null; }
    );
  }
  function onKey(event) {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    var nodes = focusables();
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
  function open() {
    /* Do not interrupt a visitor who is already in a drawer or a menu. */
    var root = document.documentElement;
    if (root.classList.contains('menu-open') || root.classList.contains('cart-open')) {
      window.setTimeout(open, 4000);
      return;
    }
    lastFocus = document.activeElement;
    modal.hidden = false;
    root.classList.add('welcome-open');
    aukStore.set(KEY, String(Date.now()));
    document.addEventListener('keydown', onKey);
    dialog.focus();
  }
  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove('welcome-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  modal.querySelectorAll('[data-welcome-close]').forEach(function (node) {
    node.addEventListener('click', close);
  });
  var copy = modal.querySelector('[data-welcome-copy]');
  var code = modal.querySelector('[data-welcome-code]');
  if (copy && code) {
    copy.addEventListener('click', function () {
      var text = code.textContent.trim();
      var done = function () { copy.textContent = 'Copied'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () {});
      }
    });
  }
  window.setTimeout(open, delay);
})();
